import { get } from '../../utils/api'
import { AxiosResponse } from 'axios'

export const fetchUsers = (page: number): Promise<AxiosResponse> =>
  get('/users', {
    page,
    size: 50,
    include: 'profile',
  })
